<template>
  <div v-if="noResultsState" class="q-container-fluid q-pb-1 q-my-1 q-text-center q-no-results-state">
    <div class="q-w-100">
      <p v-if="!loading" class="q-fw-normal q-text-dark q-mb-0 q-small">
        {{ SmartSearchTranslations.serp.emptyResults }}
      </p>
      <div id="noResultsWidgetPlaceholder">

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useSerpResultsStore } from '@/store/SerpPage/SerpResultsStore';
import { inject } from 'vue';
import { SmartSearchTranslationsInterface } from '@/core/types';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!;
const serpStore = useSerpResultsStore();
const { loading, noResultsState } = storeToRefs(serpStore);

onMounted(() => {
  if (typeof window._QONizer !== 'undefined' && typeof window._QONizer?.customSmartSearchConfig?.displayNotFoundWidget === 'function') {
    window._QONizer?.customSmartSearchConfig?.displayNotFoundWidget();
  }
});
</script>

<style scoped>
.q-full-width {
  width: 100%;
}
</style>
